<template>
  <v-card class="align-stretch" height="100%" :loading="telcoProvisioningLoading || getTelcoTariffsLoading">
    <v-card-title>
      Availability
      <BeehiveIcon :link="articleLinks.availabilityTelco" />

      <v-spacer></v-spacer>
      <v-btn color="secondary" class="ml-2" x-small @click="editAvailOpen=true;"><v-icon small>edit</v-icon></v-btn>
    </v-card-title>

    <v-card-text>
      <template v-if="telcoProvisioningLoading || getTelcoTariffsLoading">
        <v-skeleton-loader type="article, article"></v-skeleton-loader>
      </template>

      <v-row v-else>

        <v-col>

          <template v-if="getIsMobileBroadband">

            <p class="mb-1 text-caption">Maximum speed available</p>
            <p><b>{{maxSpeed}}</b></p>

            <p class="mb-1 text-caption">{{ getIsMobileBroadband ? 'Average' : 'Minimum' }} speed available</p>
            <p><b>{{minSpeed}}</b></p>

            <p class="mb-1 text-caption">Distance from exchange</p>
            <p><b>{{distance}}</b></p>
          </template>
          <template v-else>
            <p class="mb-1 text-caption">Distance from exchange</p>
            <p><b>{{distance}}</b></p>
  
            <p class="mb-1 text-caption">{{ getIsMobileBroadband ? 'Average' : 'Minimum' }} speed available</p>
            <p><b>{{minSpeed}}</b></p>
  
            <p class="mb-1 text-caption">Maximum speed available</p>
            <p><b>{{maxSpeed}}</b></p>
          </template>

        </v-col>

      </v-row>
    </v-card-text>
    <EditAvailability :dialogOpen="editAvailOpen" @close-dialog="editAvailOpen=false" />
  </v-card>
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex';
  import EditAvailability from './EditAvailability';
  import BeehiveIcon from '@/components/Globals/BeehiveIcon';
  import { articleLinks } from '@/helpers/links';
  
  export default {
    components: {EditAvailability, BeehiveIcon},

    data() {
      return {
        editAvailOpen: false,
        articleLinks,
      }
    },
    computed: {
      ...mapState('products',['currentProduct']),
      ...mapState('productTelco',['telcoProvisioning', 'telcoProvisioningLoading']),
      ...mapGetters('productTelco',['getTelcoTariffsLoading', 'getIsMobileBroadband']),

      distance(){
        let distance = this.telcoProvisioning.distance_from_exchange;
        if(distance){ return `${distance}m`; }
        return '-';
      },

      minSpeed(){
        let min = this.getIsMobileBroadband ? this.telcoProvisioning.avg_speed_available : this.telcoProvisioning.min_speed_available;
        if(min){ return `${min}mbps`; }
        return '-';
      },

      maxSpeed(){
        let max = this.telcoProvisioning.max_speed_available;
        if(max){ return `${max}mbps`; }
        return '-';
      },
    },
    methods: {
      ...mapActions('productTelco', ['fetchTelcoProvisioning']),
    },
    async mounted () {
      await this.fetchTelcoProvisioning(this.currentProduct.id);
    },
  }
</script>

<style lang="scss" scoped></style>
